export const INITIATED = 'initiated';
export const IN_PROGRESS = 'in_progress';
export const MISSED = 'missed';
export const COMPLETED = 'completed';
export const REJECTED = 'rejected';